// extracted by mini-css-extract-plugin
module.exports = {"container":"Value_container__2HpJ0","bold":"Value_bold__2yVOn"};